<ng-container *ngIf="node && node.field_layout_righe && node.field_layout_righe.length && isSpinner; else spinner">
    <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [idAnchor]="idAnchor" [positionType]="'mt-2'"
        [bgColor]="'white'" [setOffset]="250" [positionTop]="'120px'" [styleHeader]="'second'">
    </app-sample-anchor>
    <div *ngFor="let row of node.field_layout_righe; let idx = index">
        <app-row [lang]="node.langcode[0].value" [rowId]="row.target_id" [position]="idx" [attr.rowid]="row.target_id"
            [preview]="node.preview" (objAnchor)="addNewAnchorItem($event)"></app-row>
    </div>
</ng-container>
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>